import { type ValidationError, type X2jOptions, XMLParser, XMLValidator } from "fast-xml-parser"

export async function parseXMLFromURL<T = unknown>(url: string, options?: X2jOptions): Promise<T> {
  try {
    // This URL can be user-provided, but only Super Admin users are allowed to enter it
    // We can assume this URL is safe to fetch from
    // nosemgrep
    const response = await fetch(url)
    if (response.status !== 200) {
      throw new Error(`Error while fetching XML - Status code: ${response.status}`)
    }

    const xmlText = await response.text()

    const validationResult = XMLValidator.validate(xmlText)

    if (validationResult !== true) {
      const result = validationResult as ValidationError
      console.error("XML is not valid", result.err.msg)
      throw new Error("XML is not valid - " + result.err.msg)
    }

    return new XMLParser(options).parse(xmlText) as T
  } catch (error: unknown) {
    console.error(error)
    throw new Error(getErrorMessage(error), {
      cause: error,
    })
  }
}
